export enum ReplyWaitPlatform {
  EMAIL = 'EMAIL',
  SLACK = 'SLACK',
}

/** Who a wait is for. Lives only in the sealed `content` of a REPLY_WAIT ledger row: an address
 *  or Slack user id identifies a person, so none of it is a readable attribute. */
export interface ReplyWaitRecipientRef {
  platform: ReplyWaitPlatform;
  /** EMAIL: the lower-cased address. SLACK: the Slack user id. */
  identity: string;
  /** Key of the AgentOutboundEmailRecipient the address came from, when it was saved on the agent. */
  recipientKey?: string;
  slackWorkspaceId?: string;
}

/** A reply that arrived. Points at the owner's communication row (UserCommunication.messageId);
 *  the text is read from there at display time and never copied into the ledger. */
export interface ReplyWaitReplyRef {
  identity: string;
  communicationId: string;
}

/** The sealed JSON a REPLY_WAIT ledger row carries under `output.replyWait` (the same
 *  ToolResultPayload wrapper QUESTION rows use). */
export interface ReplyWaitLedgerContent {
  question: string;
  recipients: ReplyWaitRecipientRef[];
  replies?: ReplyWaitReplyRef[];
}
